import { render, staticRenderFns } from "./ScoreGraphic.vue?vue&type=template&id=b94e0de6&"
import script from "./ScoreGraphic.vue?vue&type=script&lang=js&"
export * from "./ScoreGraphic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports